<arm-side-nav [items]="advancedItems" [title]="'Advanced'" class="settings"></arm-side-nav>

